// Correctness denylist for achievement/score memory reads — NOT a feature
// flag. Module flags in this codebase fail open (unloaded/absent → enabled),
// which is the wrong default here: a wrong-region read produces sticky false
// unlocks and garbage high scores, so a system must be blocked in code until
// its underlying read path is fixed. Currently empty.
//
// gba is NOT on this list even though it needs a correctness check too — its
// check depends on the actual core instance (mgba exports GBA's two RA
// regions, IWRAM and EWRAM, as separate WASM regions, and only a rebuilt
// core reports them correctly; see gbaTwoRegionCapable in libretro-core.js),
// which a static systemId denylist has no way to express. That decision is
// owned entirely by the achievement engine's tick warmup path (engine.js
// tick()), which probes the core across a few frames and only arms gba
// achievements once the probe proves true — see MAX_WARMUP_READ_FAILURES.
// Audit 2026-07-19 for the history of gba's static block and its removal.
export const ACHIEVEMENT_BLOCKED_SYSTEMS = new Set([]);

/** Whether achievement unlocks and score-leaderboard tracking are trustworthy
 * for a system's RAM reads. False for any system in ACHIEVEMENT_BLOCKED_SYSTEMS
 * (or a missing systemId); true otherwise. Static — doesn't know about a
 * specific core instance, so it can't see gba's core-dependent correctness
 * problem (see the comment above ACHIEVEMENT_BLOCKED_SYSTEMS); the engine's
 * tick warmup path is the actual authority for that one. */
export function achievementsSupported(systemId) {
  if (!systemId) return false;
  return !ACHIEVEMENT_BLOCKED_SYSTEMS.has(systemId);
}
